<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-12 col-sm-12 bg-white shadow-sm rounded-lg border mb-5">
                <form class="m-3" @submit.prevent="submit">
                    <!-- title -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.title }}
                        </label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control" maxlength="150" v-model="title" />
                            <span class="text-danger" v-if="errors && errors.title">{{ errors.title[0] }}</span>
                        </div>
                    </div>
                    <!-- image -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.image }}
                        </label>
                        <div class="col-sm-9">
                            <label for="imageFile" role="button"><img
                                    :src="introductionData && introductionData.image ? introductionData.image_url : '/img/no-image.jpg'"
                                    class="icon-size-100" id="preview-image" ref="image"></label>
                            <span class="align-top text-danger" type="button" @click="removeImage()" v-if="image">
                                <i class="fas fa-minus-circle fa-lg"></i>
                            </span>
                            <input type="file" class="form-control-file d-none" id="imageFile" accept=".jpeg, .png, .jpg"
                                @change="uploadImage" />
                            <p class="text-danger" v-if="errors && errors.image">{{ errors.image[0] }}</p>
                        </div>
                    </div>
                    <!-- description -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.description }}
                        </label>
                        <div class="col-sm-9">
                            <textarea class="form-control" v-model="description" rows="10" maxlength="5000"></textarea>
                            <span class="text-danger" v-if="errors && errors.description">{{
                                errors.description[0]
                            }}</span>
                        </div>
                    </div>
                    <!-- link title -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.link_title }}
                        </label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control" maxlength="100" v-model="link_title" />
                            <span class="text-danger" v-if="errors && errors.link_title">{{ errors.link_title[0] }}</span>
                        </div>
                    </div>
                    <!-- link -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.link }}
                        </label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control" v-model="link" maxlength="200" />
                            <span class="text-danger" v-if="errors && errors.link">{{ errors.link[0] }}</span>
                        </div>
                    </div>
                    <!-- embed code -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.embed_code }}
                        </label>
                        <div class="col-sm-9">
                            <textarea class="form-control" v-model="embedCode" rows="10" maxlength="10000"></textarea>
                            <span class="text-danger" v-if="errors && errors.embed_code">{{
                                errors.embed_code[0]
                            }}</span>
                        </div>
                    </div>
                    <!-- default open/close -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.default_open }}
                        </label>
                        <div class="col-sm-9">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="customSwitchIsDefaultOpen"
                                    v-model="isDefaultOpen" true-value="1" false-value="0">
                                <label class="custom-control-label text-muted" for="customSwitchIsDefaultOpen"></label>
                            </div>
                            <div v-show="isDefaultOpen == 1">
                                <input
                                    type="checkbox"
                                    class="toggle toggle-primary"
                                    v-model="showOnceByCookie"
                                    :checked="showOnceByCookie"
                                    id="show-once-by-cookie"
                                    true-value="1" false-value="0"
                                />
                                <label class="col-form-label" for="show-once-by-cookie">{{ trans.show_once_by_cookie }}</label>
                            </div>
                        </div>
                    </div>
                    <!-- status -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.status }}
                        </label>
                        <div class="col-sm-9">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="customSwitch1" v-model="status"
                                    true-value="1" false-value="0">
                                <label class="custom-control-label text-muted" for="customSwitch1">{{
                                    trans.status_val[status] }}</label>
                            </div>
                        </div>
                    </div>
                </form>
                <button class="btn btn-primary w-25 center mb-4 mt-4 float-right submit-btn" :disabled="isDisabled">
                    {{ introductionData ? trans.btn.update : trans.btn.create }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        trans: {
            type: Object,
            required: true,
        },
        introductionData: {
            type: Object,
            default: function () {
                return null;
            },
        },
        formAction: {
            type: String,
            required: true,
        },
        isEdit: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            title: this.introductionData?.title ?? '',
            image: this.introductionData?.image ?? null,
            description: this.introductionData?.description ?? '',
            link: this.introductionData?.link ?? '',
            embedCode: this.introductionData?.embed_code ?? '',
            status: this.introductionData ? (this.introductionData.status ? 1 : 0) : 0,
            isDefaultOpen: this.introductionData ? (this.introductionData.is_default_open ? 1 : 0) : 0,
            errors: {},
            isDisabled: false,
            removeImg: 0,
            link_title: this.introductionData?.link_title ?? '',
            showOnceByCookie: this.introductionData ? (this.introductionData.show_once_by_cookie ? 1 : 0) : 0,
        };
    },
    methods: {
        prepareFormData() {
            let formData = new FormData();
            formData.append('title', this.title);
            if (this.image instanceof File) {
                formData.append("image", this.image);
            }
            formData.append('description', this.description);
            formData.append('link', this.link);
            formData.append('embed_code', this.embedCode);
            formData.append('status', this.status);
            formData.append('is_default_open', this.isDefaultOpen);
            formData.append('show_once_by_cookie', this.showOnceByCookie);
            if (this.isEdit) {
                formData.append('remove_image', this.removeImg);
                formData.append("_method", "PUT");
            }
            formData.append('link_title', this.link_title);
            return formData;
        },
        submit() {
            if (!this.title && !this.image && !this.description && !this.link && !this.embedCode && !this.status && !this.isDefaultOpen && !this.link_title) {
                return;
            }
            this.isDisabled = true;
            var self = this;
            axios({
                method: "POST",
                url: this.formAction,
                data: this.prepareFormData(),
                headers: {
                    "content-type": "multipart/form-data",
                },
            })
                .then((response) => {
                    if (response.data.redirectTo != undefined) {
                        window.location.replace(response.data.redirectTo);
                    }
                })
                .catch((error) => {
                    self.isDisabled = false;
                    if (error.response.status == 422) {
                        this.errors = {};
                        this.errors = error.response.data.errors;
                    }
                });
        },
        uploadImage(event) {
            if (event.target.files.length == 0) return;
            const file = event.target.files;
            if (file) {
                let previewImage = document.getElementById("preview-image");
                previewImage.src = URL.createObjectURL(file[0]);
                this.image = file[0];
                this.removeImg = 0;
            }
        },
        removeImage() {
            console.log(this.$refs);
            this.$refs.image.src = "/img/no-image.jpg";
            this.image = null;

            if(this.isEdit) {
                this.removeImg = 1;
            }
        },
        clickSubmitBtn() {
            var self = this;
            let submitBtns = document.getElementsByClassName('submit-btn');
            if (submitBtns.length > 0) {
                for (let i = 0; i < submitBtns.length; i++) {
                    const btn = submitBtns[i];
                    btn.addEventListener('click', function () {
                        self.submit();
                        this.disabled = true;
                        let formLanguages = document.querySelectorAll(".tab-content form");
                        formLanguages.forEach(function (form) {
                            var formData = new FormData(form);
                            axios.post(form.action, formData, {
                                headers: {
                                    "Content-Type": "multipart/form-data",
                                },
                            })
                        });
                    });
                }
            }
        },
    },
    mounted() {
        this.clickSubmitBtn();
    },
};
</script>

<style></style>